import { render } from "./OapImmersiveBeforeAfter.vue?vue&type=template&id=fffdc796"
import script from "./OapImmersiveBeforeAfter.vue?vue&type=script&lang=js"
export * from "./OapImmersiveBeforeAfter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__